import React, { FC } from "react"
import { StructuredText } from "react-datocms"
import { Button, ButtonVariant } from "../../components/button/Button"
import {
  HeroImage,
  HeroImageProps,
} from "../../components/hero-image/HeroImage"
import { HeroFieldsFragment } from "../gql/generated/graphql"
import { omitParagraphTagRenderRule } from "../nodeRules"

const surveyBaseUrl = process.env.NEXT_PUBLIC_WS_EXT_APP_BASE_URL

export type HeroBlockProps = {
  model: HeroFieldsFragment
} & Pick<HeroImageProps, "sectionCutColor">

export const HeroBlock: FC<HeroBlockProps> = ({ model, sectionCutColor }) => (
  <HeroImage
    title={
      <StructuredText
        data={model.title.value}
        customNodeRules={[omitParagraphTagRenderRule]}
      />
    }
    description={
      model.description && <StructuredText data={model.description.value} />
    }
    image={{
      brightness: "78%",
      originalHeight: model.backgroundImage.height,
      originalWidth: model.backgroundImage.width,
      src: model.backgroundImage.url,
    }}
    buttons={model.buttons.map(({ text, href, variant }) => {
      const finalHref = href.replace("{{surveyBaseUrl}}", surveyBaseUrl)
      return (
        <Button
          key={text}
          type="link"
          variant={variant as ButtonVariant}
          href={finalHref}
        >
          {text}
        </Button>
      )
    })}
    sectionCutColor={sectionCutColor}
  />
)
